<template>
  <div>
    <header class="site-header">

        <nav class="logo">
            <div class="logo-inner">
                <router-link :to="{name:'Home'}">
                    <img :src="StaticImageUrl+'assets/images/logo/logo-light.png'"/>
                </router-link>
            </div>
        </nav>

        <ul class="menu links">
            <li>
                <router-link :to="{name:'Home'}">صفحه اصلی</router-link>
            </li>
            <li>
                <router-link :to="{name:'AboutUs'}">درباره ما</router-link>
            </li>
            <li>
                <a>آکادمی ارزینه</a>
            </li>
            <li tabindex="1">
                <a>محصولات</a>
                <ul class="mega-menu">
                    <li><a>بازار otc</a></li>
                    <li><a>بازار تتر</a></li>
                    <li><a>آکادمی ارزینه</a></li>
                    <li><a>تریدینگ کلاب</a></li>
                    <li><a>ارزینه کارت</a></li>
                </ul>
            </li>
    
        </ul>

        <nav class="actions">

            <div class="access">
                
                <ul class="menu links langs">
                    <li tabindex="1">
                        <a class="lang" style="padding:0 6px;">
                            <i class="fa fa-globe" style="font-size: 34px;margin-top: 30px;"></i>
                        </a>
                        <ul class="mega-menu">
                            <li><a class="flag-link" data-lang="fa"><img :src="StaticImageUrl+'assets/images/irflag.png'" alt=""> فارسی</a></li>
                            <li><a class="flag-link" data-lang="en"><img :src="StaticImageUrl+'assets/images/ukflag.png'" alt=""> انگلیسی</a></li>
                            <li><a class="flag-link" data-lang="ar"><img :src="StaticImageUrl+'assets/images/qtflag.png'" alt=""> عربی</a></li>
                            <li><a class="flag-link" data-lang="ru"><img :src="StaticImageUrl+'assets/images/ruflag.png'" alt=""> روسی</a></li>
                            <li><a class="flag-link" data-lang="de"><img :src="StaticImageUrl+'assets/images/gerflag.png'" alt=""> آلمانی</a></li>
                            <li><a class="flag-link" data-lang="fr"><img :src="StaticImageUrl+'assets/images/frflag.png'" alt=""> فرانسوی</a></li>
                        </ul>
                    </li>
            
                </ul>
                
                <a class="lang flag-link" data-lang="en">
                    <img :src="StaticImageUrl+'assets/images/ukflag.png'" alt="">
                </a>
                <a class="lang flag-link" data-lang="fa">
                    <img :src="StaticImageUrl+'assets/images/irflag.png'" alt="">
                </a>
                <template v-if="authenticated">
                    <!-- <span class="text-light">{{userData.fullname}}</span> -->
                    <router-link :to="{name:'Dashboard'}"><b class="ar-btn size-md round dark mx-2">داشبورد</b></router-link>
                </template>
                <template v-if="!authenticated">
                    <router-link :to="{name:'LoginByPassword'}"><button class="ar-btn size-md round dark">{{ $t('menu.login') }}</button></router-link>
                    <router-link :to="{name:'Register'}"><button class="ar-btn size-md round dark mx-2">{{ $t('menu.register') }}</button></router-link>
                </template>
            </div>
            <span @click="menu_open = !menu_open" class="side-nav-toggler">
                <i class="fa fa-bars"></i>
            </span>

        </nav>

    </header>

    <div @click.self="menu_open = !menu_open" class="site-sidenav" :class="[menu_open ? 'active' : '']">
        <div class="sidenav-menu">
            <div class="logo">
                <router-link :to="{name:'Home'}">
                    <img :src="StaticImageUrl+'assets/images/logo/logo-dark.png'"/>
                </router-link>
            </div>
            <button @click="menu_open = !menu_open" class="button button-circle button-close-sidenav"></button>
            <ul class="menu mb-0">
                <li>
                    <router-link :to="{name:'Home'}"><i class="fa fa-home"></i> صفحه اصلی</router-link>
                </li>
                <li>
                    <router-link :to="{name:'AboutUs'}"><i class="fa fa-user-circle-o"></i> درباره ما</router-link>
                </li>
                <li>
                    <a><i class="fa fa-graduation-cap"></i> آکادمی ارزینه</a>
                </li>
                <li>
                    <a><i class="fa fa-money"></i> محصولات</a>
                </li>
                
                
            </ul>
            <div class="lang">
                <ul class="menu auth">
                    <template v-if="authenticated">
                        <li>
                            <router-link :to="{name:'Dashboard'}"><b class="ar-btn size-sm round primary">ورود به داشبورد</b></router-link>
                        </li>
                    </template>
                    
                    <template v-if="!authenticated">
                        <li>
                            <div class="d-flex px-4">
                                <router-link class=" p-2" :to="{name:'LoginByPassword'}"><button class="ar-btn size-sm round primary">{{ $t('menu.login') }}</button></router-link>
                                <router-link class=" p-2" :to="{name:'Register'}"><button class="ar-btn size-sm round primary">{{ $t('menu.register') }}</button></router-link>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
    <div id="google_translate_element"></div>
  </div>
</template>
<script>
import LogoutBtn from '../components/LogoutBtn'
export default {
  name: 'Header',
  data : () => ({
    menu_open : false
  }),
  watch:{
    $route (to, from){
      this.menu_open = false
    }
  },
  components:{
    LogoutBtn,
  },
  methods:{
  },
  mounted() {

    var flags = document.getElementsByClassName('flag-link');
    console.log(flags);

    Array.prototype.forEach.call(flags, function(e){
        e.addEventListener('click', function(){
            var lang = e.getAttribute('data-lang'); 
            var languageSelect = document.querySelector("select.goog-te-combo");
            languageSelect.value = lang; 
            languageSelect.dispatchEvent(new Event("change"));
        }); 
    });

  }
}
</script>
<style scoped>
.spacer{
    width: 100%;
    height: 100px;
}
#google_translate_element{
  display: none;
}
</style>